module.exports = __webpack_public_path__ + "static/media/BubblePop.49242471.svg";